var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import i18n from "../../components/i18next/i18n";
import { Config } from "../../../../utils/config";
import { FORM_ELEMENTS_CLASSES, NODE_NAMES } from "../../utils/form-builder.types";
import { formBuilderCustomTranslations } from "./form-builder.translations";
import { createI18nInstance } from "../../components/i18next/i18n.instance";
export const translatableKeys = ["nodeValue", "placeholder", "content", "src", "alt", "href"];
const findAllElementTranslations = (element) => {
  const translations = /* @__PURE__ */ new Set();
  const findTranslations = (elements) => {
    if (elements && translations) {
      elements.forEach((nestedEl) => {
        for (const key in nestedEl) {
          if (translatableKeys.some((tk) => tk === key)) {
            translations.add(nestedEl[key]);
          }
        }
        if (nestedEl == null ? void 0 : nestedEl.elements) {
          findTranslations(nestedEl.elements);
        }
      });
    }
  };
  if (Array.isArray(element)) {
    findTranslations(element);
  } else {
    (element == null ? void 0 : element.elements) && findTranslations(element.elements);
  }
  return translations;
};
const removeUnusedTranslations = (locales, translations) => {
  if (locales, translations) {
    for (const key of translations) {
      for (const locale in locales) {
        if (locales[locale].hasOwnProperty(key)) {
          delete locales[locale][key];
        }
      }
    }
  }
};
const _createTranslationKey = (prefix = "") => {
  return `${prefix}.${Math.random().toString(36).substring(2).toUpperCase()}`;
};
const generateTranslation = (elementClass, element, prop) => {
  return _createTranslationKey(
    `FORM.${elementClass.toUpperCase()}.${element.nodeName.toUpperCase()}.${prop.toUpperCase()}`
  );
};
const _handleElementTranslations = (elementClass, element, translations) => {
  if (translatableKeys.some((key) => key in element)) {
    Object.keys(element).forEach((prop) => {
      const key = generateTranslation(elementClass, element, prop);
      if (translatableKeys.includes(prop)) {
        if (elementClass === FORM_ELEMENTS_CLASSES.CONSENT && prop === "href") return;
        if ((elementClass === FORM_ELEMENTS_CLASSES.VIMEO || elementClass === FORM_ELEMENTS_CLASSES.YOUTUBE) && prop === "src")
          return;
        translations[key] = element[prop];
        element[prop] = key;
      }
    });
  }
  if (element.elements) {
    element.elements.forEach((e) => _handleElementTranslations(elementClass, e, translations));
  }
};
const addTranslationsToElement = (originalElement) => {
  const translations = {};
  const element = JSON.parse(JSON.stringify(originalElement));
  _handleElementTranslations(element.class, element, translations);
  if (element.class === FORM_ELEMENTS_CLASSES.FILE_UPLOAD) {
    const input = element.elements.find((el) => el.nodeName === NODE_NAMES.INPUT);
    const dataLocale = JSON.parse(input["data-locale"]);
    const dataLocaleTranslations = Object.entries(dataLocale).map(([key, tr]) => {
      const value = formBuilderCustomTranslations["data-locale"][key];
      return { [tr]: value };
    }).reduce((acc, obj) => {
      const key = Object.keys(obj)[0];
      acc[key] = obj[key];
      return acc;
    }, {});
    return { element, translations: __spreadValues(__spreadValues({}, dataLocaleTranslations), translations) };
  }
  return { element, translations };
};
const updateMultipleTranslations = (lang, translations) => {
  i18n.addResourceBundle(lang, "translation", translations);
};
const updateSingleTranslation = (lang, key, value) => {
  i18n.addResource(lang, "translation", key, value);
};
const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
};
const getCurrentFormLanguage = (storedLanguage, translations = {}) => {
  var _a;
  if (!translations) return;
  const languageKeys = Object == null ? void 0 : Object.keys(translations);
  const splitLang = (_a = storedLanguage == null ? void 0 : storedLanguage.replace("-", "_")) == null ? void 0 : _a.split("_");
  const similarLanguages = (languageKeys == null ? void 0 : languageKeys.filter((lang) => {
    var _a2, _b;
    return (_b = lang == null ? void 0 : lang.toLowerCase()) == null ? void 0 : _b.includes((_a2 = splitLang == null ? void 0 : splitLang[0]) == null ? void 0 : _a2.toLowerCase());
  })) || [];
  const mainLanguage = similarLanguages.find(
    (lang) => {
      var _a2;
      return ((_a2 = lang == null ? void 0 : lang.toLowerCase()) == null ? void 0 : _a2.includes(Config.language.defaultLanguage.toLowerCase())) ? lang : (lang == null ? void 0 : lang.length) === 2;
    }
  );
  const languageWithTranslation = similarLanguages.find(
    (simlang) => (simlang == null ? void 0 : simlang.toLowerCase()) === (storedLanguage == null ? void 0 : storedLanguage.toLowerCase())
  );
  if (languageWithTranslation) return languageWithTranslation;
  if (mainLanguage) return mainLanguage;
  if (similarLanguages[0]) return similarLanguages[0];
  return languageKeys[0];
};
const init = (translations, lang) => {
  if (!translations) return;
  const language = getCurrentFormLanguage(lang, translations);
  for (let lang2 in translations) {
    const currentContent = translations[lang2];
    translations[lang2] = { translation: currentContent };
  }
  const initValues = {
    lng: language,
    fallbackLng: Config.language.defaultLanguage,
    resources: translations,
    keySeparator: "*",
    saveMissing: true,
    returnEmptyString: true,
    fallbackValue: false,
    returnNull: false,
    interpolation: {
      escapeValue: false
    },
    missingKeyHandler: () => {
      return "";
    },
    parseMissingKeyHandler: () => {
      return "";
    }
  };
  const i18Instance = createI18nInstance(initValues);
  return { language, i18Instance };
};
export const FormBuilderTranslatorService = {
  findAllElementTranslations,
  removeUnusedTranslations,
  getCurrentFormLanguage,
  addTranslationsToElement,
  updateSingleTranslation,
  updateMultipleTranslations,
  generateTranslation,
  changeLanguage,
  init
};
